namespace GeniuzPOS.ReportMasterData {
    export interface Report_1303Form {
    }

    export class Report_1303Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1303';
    }
}
